<div class="container">
  <div class="row">
    <h3 *ngIf="crudMode" class="page-title" style="margin-left: 15px;">Receitas</h3>
    <button
        class="btn btn-link ml-auto"
        [hidden]="prescribing || !crudMode"
        (click)="startPrescribing()"
        style="padding-top: 0px; padding-bottom: 0px; margin-top: -20px;"
        data-toggle="tooltip" title="Receita avulsa">
      <fa-icon [icon]="editIcon" class="fa-2x mr-3"></fa-icon>
    </button>
  </div>

  <input
    [hidden]="prescribing"
    type="text"
    autofocus
    class="form-control"
    style="margin-bottom: 15px;"
    #searchBox
    id="searchBox"
    placeholder="Digite o nome da receita para pesquisar"
    (keyup)="search(searchBox.value)" />

  <mc-prescription-template-list [templates]="templates" [crudMode]="crudMode" (selected)="selectedTemplate($event)"></mc-prescription-template-list>

  <blockquote class="blockquote text-center mt-5" *ngIf="templates?.length == 0">
    <p *ngIf="crudMode">Nenhuma receita foi encontrada, gostaria de
      <span class="h4"><strong><em>
            <a class="btn btn-outline-primary btn-lg ml-1" routerLink="nova">criar uma nova?</a>
      </em></strong></span>
    </p>
    <p *ngIf="!crudMode">Nenhuma receita foi encontrada.</p>
  </blockquote>

  <mc-prescription-form
      *ngIf="prescribing"
      (canceled)="onPrescribingCanceled()"
      (printed)="onPrinted($event)"
      [prescription]="prescription"
      [detached]="true">
    </mc-prescription-form>
</div>
